import requestIdleCallback from '../shims/requestIdleCallback';

export function setVh(): void {
    document.documentElement.style.setProperty( '--vh', `${window.innerHeight * 0.01}px` );
}

export function setVhAsync(): Promise<void> {
    return new Promise( ( resolve, reject ) => {
        requestIdleCallback( () => {
            setVh();
            resolve();
        } );
    } );
}

export function initVhUnit( set = true ): void {
    if ( set ) {
        setVhAsync();
    }

    [
        'resize',
        'orientationchange',
    ].forEach( ( windowEvent: string ) => window.addEventListener( windowEvent, setVhAsync ) );
}
